var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-row",
        { attrs: { id: "stat-row", dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "unskew", attrs: { cols: "2", offset: "1" } },
            [
              _c(
                "cc-tooltip",
                {
                  attrs: {
                    simple: "",
                    inline: "",
                    delay: "",
                    content:
                      "Structure: " +
                      _vm.mech.CurrentStructure +
                      "/" +
                      _vm.mech.MaxStructure
                  }
                },
                [_c("v-icon", [_vm._v("cci-structure")])],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-text" }, [
                _vm._v(_vm._s(_vm.mech.CurrentStructure))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "flavor-text subtle--text",
                  staticStyle: { "font-size": "14px" }
                },
                [
                  _vm._v(
                    "\n        /" + _vm._s(_vm.mech.MaxStructure) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "unskew", attrs: { cols: "2" } },
            [
              _c(
                "cc-tooltip",
                {
                  attrs: {
                    simple: "",
                    inline: "",
                    delay: "",
                    content: "HP: " + _vm.mech.CurrentHP + "/" + _vm.mech.MaxHP
                  }
                },
                [_c("v-icon", [_vm._v("mdi-heart-outline")])],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-text" }, [
                _vm._v(_vm._s(_vm.mech.CurrentHP))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "flavor-text subtle--text",
                  staticStyle: { "font-size": "14px" }
                },
                [_vm._v("/" + _vm._s(_vm.mech.MaxHP))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "unskew", attrs: { cols: "2" } },
            [
              _c(
                "cc-tooltip",
                {
                  attrs: {
                    simple: "",
                    inline: "",
                    delay: "",
                    content:
                      "Reactor Stress: " +
                      _vm.mech.CurrentStress +
                      "/" +
                      _vm.mech.MaxStress
                  }
                },
                [_c("v-icon", [_vm._v("cci-reactor")])],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-text" }, [
                _vm._v(_vm._s(_vm.mech.CurrentStress))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "flavor-text subtle--text",
                  staticStyle: { "font-size": "14px" }
                },
                [_vm._v("/" + _vm._s(_vm.mech.MaxStress))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "unskew", attrs: { cols: "2" } },
            [
              _c(
                "cc-tooltip",
                {
                  attrs: {
                    simple: "",
                    inline: "",
                    delay: "",
                    content:
                      "Heat: " +
                      _vm.mech.CurrentHeat +
                      "/" +
                      _vm.mech.HeatCapacity
                  }
                },
                [_c("v-icon", [_vm._v("mdi-fire")])],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-text" }, [
                _vm._v(_vm._s(_vm.mech.CurrentHeat))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "flavor-text subtle--text",
                  staticStyle: { "font-size": "14px" }
                },
                [
                  _vm._v(
                    "\n        /" + _vm._s(_vm.mech.HeatCapacity) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "unskew", attrs: { cols: "2" } },
            [
              _c(
                "cc-tooltip",
                {
                  attrs: {
                    simple: "",
                    inline: "",
                    delay: "",
                    content:
                      "Repair Capacity: " +
                      _vm.mech.CurrentRepairs +
                      "/" +
                      _vm.mech.RepairCapacity
                  }
                },
                [_c("v-icon", [_vm._v("cci-repair")])],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-text" }, [
                _vm._v(_vm._s(_vm.mech.CurrentRepairs))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "flavor-text subtle--text",
                  staticStyle: { "font-size": "14px" }
                },
                [
                  _vm._v(
                    "\n        /" + _vm._s(_vm.mech.RepairCapacity) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }